import { render, staticRenderFns } from "./DateTab2.vue?vue&type=template&id=690fa19e&scoped=true"
import script from "./DateTab2.vue?vue&type=script&lang=js"
export * from "./DateTab2.vue?vue&type=script&lang=js"
import style0 from "./DateTab2.vue?vue&type=style&index=0&id=690fa19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690fa19e",
  null
  
)

export default component.exports